import angular from 'angular';
import { collapsibleDirective } from './collapsible/collapsibleDirective';
import { collapseWhenDirective } from './collapseWhen/collapseWhenDirective';
import './collapsible.css';

angular
	.module('sh.collapsible', [])
	.directive('shCollapsible', collapsibleDirective)
	.directive('shCollapseWhen', collapseWhenDirective);
